var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 56,
    viewBox: "0 0 189 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-play_svg__clip0_1248_30486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182 0H7a7 7 0 00-7 7v42a7 7 0 007 7h175a7 7 0 007-7V7a7.003 7.003 0 00-7-7z",
    fill: props.fill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182 1.12A5.882 5.882 0 01187.88 7v42a5.872 5.872 0 01-1.721 4.159A5.883 5.883 0 01182 54.88H7A5.88 5.88 0 011.12 49V7A5.88 5.88 0 017 1.12h175zM182 0H7a7 7 0 00-7 7v42a7 7 0 007 7h175a7.004 7.004 0 007-7V7a7.002 7.002 0 00-7-7z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.395 30.45a5.95 5.95 0 105.979 5.95 5.87 5.87 0 00-5.979-5.95zm0 9.562a3.612 3.612 0 113.36-3.612 3.445 3.445 0 01-3.36 3.612zM82.361 30.45a5.95 5.95 0 105.964 5.95 5.869 5.869 0 00-5.978-5.95h.014zm0 9.562a3.612 3.612 0 113.346-3.612 3.445 3.445 0 01-3.36 3.612h.014zm-15.526-7.728v2.52h6.048a5.278 5.278 0 01-1.4 3.178 6.19 6.19 0 01-4.662 1.848 6.72 6.72 0 110-13.44 6.44 6.44 0 014.578 1.806l1.778-1.778a8.807 8.807 0 00-6.342-2.618 9.252 9.252 0 100 18.494 8.4 8.4 0 006.454-2.59 8.4 8.4 0 002.184-5.908 8.222 8.222 0 00-.14-1.582l-8.498.07zm63.435 1.96a5.6 5.6 0 00-5.096-3.794 5.601 5.601 0 00-5.6 5.95 5.83 5.83 0 001.69 4.23 5.815 5.815 0 004.218 1.72 5.921 5.921 0 004.956-2.632l-2.03-1.4a3.402 3.402 0 01-2.926 1.652 3.022 3.022 0 01-2.884-1.806l7.966-3.29-.294-.63zm-8.12 1.988a3.261 3.261 0 013.108-3.472 2.31 2.31 0 012.212 1.26l-5.32 2.212zM115.682 42h2.618V24.5h-2.618V42zm-4.284-10.22h-.098a4.2 4.2 0 00-3.136-1.4 5.967 5.967 0 00-5.675 5.957 5.966 5.966 0 005.675 5.957 4.06 4.06 0 003.136-1.4h.084v.854c0 2.282-1.218 3.5-3.178 3.5a3.288 3.288 0 01-2.996-2.114l-2.282.952a5.663 5.663 0 005.278 3.514c3.066 0 5.6-1.806 5.6-6.202V30.8h-2.408v.98zm-2.996 8.232a3.626 3.626 0 010-7.224 3.366 3.366 0 012.35 1.136 3.36 3.36 0 01.828 2.476c.038.449-.015.901-.156 1.33a3.321 3.321 0 01-3.036 2.283h.014zM142.534 24.5h-6.258V42h2.618v-6.636h3.654a5.443 5.443 0 005.814-5.432 5.448 5.448 0 00-1.727-3.979 5.455 5.455 0 00-4.087-1.453h-.014zm0 8.4h-3.654v-5.964h3.71a3.006 3.006 0 012.123 5.127 3.004 3.004 0 01-2.123.879l-.056-.042zm16.142-2.52a4.899 4.899 0 00-4.662 2.674l2.324.966a2.478 2.478 0 012.38-1.288 2.527 2.527 0 012.509 1.303c.159.294.257.618.291.951v.182a5.784 5.784 0 00-2.73-.672c-2.506 0-5.04 1.4-5.04 3.934a4.076 4.076 0 001.356 2.842 4.057 4.057 0 002.984 1.008 3.688 3.688 0 003.36-1.68h.084V42h2.52v-6.734c0-3.066-2.324-4.844-5.306-4.844l-.07-.042zm-.322 9.59c-.854 0-2.044-.434-2.044-1.484 0-1.4 1.484-1.862 2.8-1.862a4.652 4.652 0 012.38.588 3.173 3.173 0 01-3.066 2.8l-.07-.042zm14.882-9.17l-2.996 7.588h-.084l-3.108-7.588h-2.8l4.662 10.612-2.66 5.894h2.73l7.168-16.506h-2.912zM149.702 42h2.618V24.5h-2.618V42z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.616 10.556a2.8 2.8 0 00-.644 1.96v30.968a2.8 2.8 0 00.644 1.96l.098.098L32.06 28.21v-.405L14.714 10.459l-.098.098z",
    fill: "url(#google-play_svg__paint0_linear_1248_30486)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8 33.992l-5.74-5.782v-.406l5.74-5.796.126.07 6.874 3.906c1.96 1.106 1.96 2.926 0 4.046l-6.846 3.892-.154.07z",
    fill: "url(#google-play_svg__paint1_linear_1248_30486)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.968 33.908L32.06 28 14.616 45.444a2.282 2.282 0 002.912.084l20.454-11.62",
    fill: "url(#google-play_svg__paint2_linear_1248_30486)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.968 22.092l-20.454-11.62a2.282 2.282 0 00-2.912.084L32.06 28l5.908-5.908z",
    fill: "url(#google-play_svg__paint3_linear_1248_30486)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.8 33.782l-20.286 11.55a2.338 2.338 0 01-2.8 0l-.098.098.098.098a2.324 2.324 0 002.8 0l20.454-11.62-.168-.126z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M14.616 45.248a2.8 2.8 0 01-.644-1.96v.21a2.8 2.8 0 00.644 1.96l.098-.098-.098-.112zM44.8 29.82l-7 3.962.126.126 6.874-3.892A2.45 2.45 0 0046.2 28a2.605 2.605 0 01-1.4 1.82z",
    fill: props.fill
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M17.514 10.668L44.8 26.18A2.604 2.604 0 0146.2 28a2.449 2.449 0 00-1.4-2.016L17.514 10.472c-1.96-1.106-3.556-.182-3.556 2.058v.21c.042-2.254 1.61-3.178 3.556-2.072z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.038 18.2H57.96V9.8h2.8a2.66 2.66 0 011.848.714 2.435 2.435 0 010 3.584c-.5.468-1.163.724-1.848.714h-1.722V18.2zm0-4.438h1.806a1.401 1.401 0 001.092-.462 1.4 1.4 0 000-2.016 1.4 1.4 0 00-1.092-.462h-1.806v2.94zm12.642 3.346a4.368 4.368 0 01-6.16 0 4.536 4.536 0 010-6.23 4.34 4.34 0 016.16 0 4.522 4.522 0 010 6.23zm-5.362-.7a3.234 3.234 0 004.564 0 3.584 3.584 0 000-4.816 3.234 3.234 0 00-4.564 0 3.584 3.584 0 000 4.816zm8.12 1.792V9.8h3.038a2.464 2.464 0 011.708.644 2.113 2.113 0 01.728 1.638c.007.373-.1.74-.308 1.05-.206.302-.492.54-.826.686a2.13 2.13 0 011.022.728c.269.343.413.769.406 1.204a2.198 2.198 0 01-.756 1.708 2.59 2.59 0 01-1.792.686l-3.22.056zm1.078-4.802h1.96a1.26 1.26 0 00.98-.406A1.246 1.246 0 0078.4 11.2a1.203 1.203 0 00-.938-.406h-1.946v2.604zm0 3.766h2.17a1.29 1.29 0 001.008-.434 1.4 1.4 0 00.392-.952 1.4 1.4 0 00-1.4-1.4h-2.17v2.786zm6.118 1.036V9.8h1.078v8.4h-1.078zm7.966-7.364h-3.878v2.66h3.444v1.008h-3.444v2.66H89.6V18.2h-4.9V9.8h4.9v1.036zm1.638 7.364V9.8h2.8a2.66 2.66 0 011.848.714 2.422 2.422 0 01.21 3.346c-.357.434-.85.736-1.4.854l2.352 3.486h-1.274l-2.268-3.402h-1.204V18.2h-1.064zm1.078-4.41h1.736c.41.008.805-.142 1.106-.42a1.4 1.4 0 00.462-1.064 1.484 1.484 0 00-.406-1.008 1.4 1.4 0 00-1.092-.462h-1.806v2.954zm5.474 4.41v-1.12l4.41-6.244H98V9.8h5.6v1.12l-4.466 6.244h4.466V18.2h-5.81zm9.66 0v-1.12l4.466-6.244h-4.284V9.8h5.6v1.12l-4.466 6.244h4.522V18.2h-5.838z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint0_linear_1248_30486",
    x1: 30.52,
    y1: 12.194,
    x2: 7.028,
    y2: 35.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint1_linear_1248_30486",
    x1: 47.362,
    y1: 28,
    x2: 13.496,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint2_linear_1248_30486",
    x1: 34.762,
    y1: 31.22,
    x2: 2.898,
    y2: 63.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint3_linear_1248_30486",
    x1: 10.22,
    y1: 0.252,
    x2: 24.445,
    y2: 14.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google-play_svg__clip0_1248_30486"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h189v56H0z"
  })))));
}
export default SvgGooglePlay;